import { render, staticRenderFns } from "./SongListInfo.vue?vue&type=template&id=04c7af7f&scoped=true&"
import script from "./SongListInfo.vue?vue&type=script&lang=js&"
export * from "./SongListInfo.vue?vue&type=script&lang=js&"
import style0 from "./SongListInfo.vue?vue&type=style&index=0&id=04c7af7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7af7f",
  null
  
)

export default component.exports